import * as yup from "yup";

export const AdminEmail = yup.object().shape({
	email: yup.string().email("Email must be a valid email").required("Email is required")
});
